var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramBrandsSolidFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 640 640",
    style: {
      enableBackground: "new 0 0 640 640"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M320.3,205c-63.5-0.2-115.1,51.2-115.3,114.7S256.2,434.8,319.7,435S434.8,383.8,435,320.3 S383.8,205.2,320.3,205z M319.7,245.4c41.2-0.2,74.7,33.1,74.9,74.3c0.2,41.2-33.1,74.7-74.3,74.9c-41.2,0.2-74.7-33.1-74.9-74.3 C245.2,279.1,278.5,245.6,319.7,245.4z M413.1,200.3c0-14.8,12-26.8,26.8-26.8c14.8,0,26.8,12,26.8,26.8s-12,26.8-26.8,26.8 C425.1,227.1,413.1,215.1,413.1,200.3z M542.8,227.5c-1.7-35.9-9.9-67.7-36.2-93.9c-26.2-26.2-58-34.4-93.9-36.2 c-37-2.1-147.9-2.1-184.9,0c-35.8,1.7-67.6,9.9-93.9,36.1s-34.4,58-36.2,93.9c-2.1,37-2.1,147.9,0,184.9 c1.7,35.9,9.9,67.7,36.2,93.9s58,34.4,93.9,36.2c37,2.1,147.9,2.1,184.9,0c35.9-1.7,67.7-9.9,93.9-36.2c26.2-26.2,34.4-58,36.2-93.9 C544.9,375.3,544.9,264.5,542.8,227.5z M495,452c-7.8,19.6-22.9,34.7-42.6,42.6c-29.5,11.7-99.5,9-132.1,9s-102.7,2.6-132.1-9 c-19.6-7.8-34.7-22.9-42.6-42.6c-11.7-29.5-9-99.5-9-132.1s-2.6-102.7,9-132.1c7.8-19.6,22.9-34.7,42.6-42.6 c29.5-11.7,99.5-9,132.1-9s102.7-2.6,132.1,9c19.6,7.8,34.7,22.9,42.6,42.6c11.7,29.5,9,99.5,9,132.1S506.7,422.6,495,452z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramBrandsSolidFull);
export default __webpack_public_path__ + "static/media/instagram-brands-solid-full.bc62b233bcdf6444660d5cef76ffc712.svg";
export { ForwardRef as ReactComponent };